import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateStpEntitiesAction, UpdateStpSuppliersActions } from "./actions";
import { IEntityStpTableData, IStpSupplierTableData } from "../interfaces/stp";
import { ConfigMap } from "../../configMap";
import { OrganizationSettings } from "../../user/interfaces/responseModels";

interface OrganizationStpSettings {
  stpEntitiesDocumentType: Array<IEntityStpTableData>;
  stpEntities: Array<IEntityStpTableData>;
  suppliers: Array<IStpSupplierTableData>;
}

interface OrganizationSettingsState {
  configMap: ConfigMap | null;
  documentTypeId: string | null;
  stp: OrganizationStpSettings;
  uiSettings: OrganizationSettings | null;
}

interface OrganizationState {
  settings: OrganizationSettingsState;
}

const initialState: OrganizationState = {
  settings: {
    uiSettings: null,
    configMap: null,
    documentTypeId: null,
    stp: {
      stpEntitiesDocumentType: [],
      stpEntities: [],
      suppliers: [],
    },
  },
};

export const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setStpEntitiesDocumentType: (
      state,
      action: PayloadAction<UpdateStpEntitiesAction>,
    ) => {
      const { entities } = action.payload;
      state.settings.stp.stpEntitiesDocumentType = entities;
    },
    setStpEntities: (state, action: PayloadAction<UpdateStpEntitiesAction>) => {
      const { entities } = action.payload;
      state.settings.stp.stpEntities = entities;
    },
    addStpEntity: (state, action: PayloadAction<IEntityStpTableData>) => {
      const stpEntity = action.payload;
      state.settings.stp.stpEntities.push(stpEntity);
    },
    removeStpEntity: (state, action: PayloadAction<string>) => {
      state.settings.stp.stpEntities = state.settings.stp.stpEntities.filter(
        (stpEntity) => stpEntity.id !== action.payload,
      );
    },
    setStpSuppliers: (
      state,
      action: PayloadAction<UpdateStpSuppliersActions>,
    ) => {
      const { suppliers } = action.payload;
      state.settings.stp.suppliers = suppliers;
    },
    setSelectedConfigMap: (state, action: PayloadAction<ConfigMap | null>) => {
      state.settings.configMap = action.payload;
    },
    setSelectedDocumentTypeId: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.settings.documentTypeId = action.payload;
    },
    setUiSettings: (state, action: PayloadAction<OrganizationSettings>) => {
      state.settings.uiSettings = action.payload;
    },
  },
});

export const {
  setStpEntitiesDocumentType,
  setStpEntities,
  setStpSuppliers,
  setSelectedConfigMap,
  setSelectedDocumentTypeId,
  setUiSettings,
} = organizationSlice.actions;

export default organizationSlice.reducer;
